(() => {
  const handoffPrefix = '#he-rec-basket=';
  const brandHosts = new Set(['heartjesusart.org','heartjesusart.com','heartcooking.org','heartcooking.com','wearenabledart.org','wearenabledart.com','heartgardening.org','heartworship.org','heartpoetry.org','seathletique.com']);
  const cleanHost = host => host.toLowerCase().replace(/^www\./, '');
  const allowedBrand = url => url.protocol === 'https:' && brandHosts.has(cleanHost(url.hostname));
  const canonicalBrand = value => String(value || '').trim().replace(/^He Art® cooking$/i, 'He Art cooking®');
  const brandAtHost = host => ({
    'heartjesusart.org':'He Art®','heartjesusart.com':'He Art®',
    'heartcooking.org':'He Art cooking®','heartcooking.com':'He Art cooking®',
    'wearenabledart.org':'wearenabledart®','wearenabledart.com':'wearenabledart®',
    'heartgardening.org':'He Art® gardening','heartworship.org':'He Art® music',
    'heartpoetry.org':'He Art® poetry','seathletique.com':'Seathletique'
  })[cleanHost(host)] || 'He Art®';
  const showFormProblem = (form, message) => {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (wrapper && text) { text.textContent = message; wrapper.hidden = false; }
    else window.alert(message);
  };
  const bindOwningBrandCart = (product, fullUrl) => {
    const submit = product.querySelector('.pdp-basket button[name="add"], product-form button[name="add"]');
    const form = submit?.closest('form');
    if (!form || form.dataset.heRecBrandBound) return;
    form.dataset.heRecBrandBound = 'true';
    form.addEventListener('submit', event => {
      const target = new URL(fullUrl, location.href);
      if (target.origin === location.origin || !allowedBrand(target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      try {
        const fields = new FormData(form);
        const id = String(fields.get('id') || '');
        const quantity = Number(fields.get('quantity') || 1);
        if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1 || quantity > 100000) throw new Error('Please choose an available variant and quantity.');
        const item = { id, quantity };
        const plan = fields.get('selling_plan');
        if (plan) {
          if (!/^\d+$/.test(String(plan))) throw new Error('Please select a valid purchase option.');
          item.selling_plan = String(plan);
        }
        const properties = {};
        for (const [key, value] of fields.entries()) {
          if (typeof value !== 'string') {
            if (value.size > 0) throw new Error('Please open VIEW FULL DETAILS to add a product with a file attachment on its brand storefront.');
            continue;
          }
          const match = key.match(/^properties\[(.*)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        const payload = { version: 1, origin: target.origin, path: target.pathname, created: Date.now(), brand: canonicalBrand(product.dataset.heRecBrand || brandAtHost(target.hostname)), item };
        const encoded = encodeURIComponent(JSON.stringify(payload));
        if (encoded.length > 16000) throw new Error('Please use VIEW FULL DETAILS to add this personalised product on its brand storefront.');
        target.searchParams.set('variant', id);
        target.hash = handoffPrefix + encoded;
        if (window.Shopify?.designMode && window.top !== window) {
          const opened = window.open(target.href, '_blank');
          if (opened) opened.opener = null;
          else throw new Error('Please allow the new brand-store tab, or open VIEW FULL DETAILS to continue there.');
        } else location.assign(target.href);
      } catch (error) { showFormProblem(form, error.message || 'Please open the product on its brand storefront to continue.'); }
    }, { capture: true });
  };
  const consumeBrandHandoff = async () => {
    if (!location.hash.startsWith(handoffPrefix) || window.heRecBrandHandoffRunning) return;
    window.heRecBrandHandoffRunning = true;
    const encoded = location.hash.slice(handoffPrefix.length);
    history.replaceState(history.state, '', location.pathname + location.search);
    let payload;
    try {
      if (encoded.length > 16000) throw new Error('Invalid basket link.');
      payload = JSON.parse(decodeURIComponent(encoded));
      const origin = new URL(payload.origin);
      if (!allowedBrand(origin) || cleanHost(origin.hostname) !== cleanHost(location.hostname)
        || String(payload.path).replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')
        || payload.version !== 1 || !Number.isFinite(payload.created)
        || Math.abs(Date.now() - payload.created) > 300000
        || !/^\d+$/.test(String(payload.item?.id)) || !Number.isInteger(payload.item?.quantity)
        || payload.item.quantity < 1 || payload.item.quantity > 100000) throw new Error('This basket link has expired or is invalid.');
      if (payload.item.selling_plan && !/^\d+$/.test(String(payload.item.selling_plan))) throw new Error('Invalid purchase option.');
      if (payload.item.properties && (typeof payload.item.properties !== 'object' || Array.isArray(payload.item.properties))) throw new Error('Invalid product options.');
    } catch (error) {
      window.heRecBrandHandoffRunning = false;
      window.alert(error.message || 'Please add this item directly from its product page.');
      return;
    }
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const cart = new URL(root + 'cart', location.origin);
    const veil = document.createElement('div');
    veil.setAttribute('role', 'status');
    veil.setAttribute('aria-live', 'polite');
    veil.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:grid;place-content:center;gap:18px;padding:24px;text-align:center;background:#fff;color:#242424;font:16px/1.5 sans-serif;';
    const text = document.createElement('p');
    const savedBrand = document.querySelector?.('[data-he-rec-current-brand]')?.getAttribute('data-he-rec-current-brand');
    text.textContent = 'Taking you to ' + canonicalBrand(savedBrand || payload.brand || brandAtHost(location.hostname)) + '’s basket…';
    veil.appendChild(text);
    document.body.appendChild(veil);
    try {
      // This request runs AFTER top-level navigation, on the owning domain with
      // that domain's existing cart cookie. It never adds to the source cart.
      const response = await fetch(new URL(root + 'cart/add.js', location.origin), {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [payload.item] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'The item could not be added.');
      location.replace(cart.href);
    } catch (error) {
      veil.setAttribute('role', 'alert');
      text.textContent = (error.message || 'We could not confirm the item was added.') + ' Check this basket before trying again.';
      const basket = document.createElement('a');
      basket.href = cart.href;
      basket.textContent = 'VIEW BASKET';
      const back = document.createElement('button');
      back.type = 'button';
      back.textContent = 'BACK TO PRODUCT';
      back.addEventListener('click', () => veil.remove());
      veil.append(basket, back);
    }
  };

  const recentKey = 'he-rec-recent-products-v1';
  let recentMemory = [];
  const recentCards = new Map();
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9_-]{0,254}$/i.test(value);
  const recentRead = () => {
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(recentKey) || '[]');
      if (Array.isArray(stored)) recentMemory = stored.filter(validHandle).slice(0, 8);
    } catch (_) {}
    return recentMemory.slice();
  };
  const recentRemember = handle => {
    if (!validHandle(handle)) return;
    recentMemory = [handle, ...recentRead().filter(item => item !== handle)].slice(0, 8);
    try { window.sessionStorage.setItem(recentKey, JSON.stringify(recentMemory)); } catch (_) {}
  };
  const pageHandle = () => {
    const rendered = document.querySelector?.('product-recommendations[data-he-rec-current-handle]')?.getAttribute('data-he-rec-current-handle');
    if (validHandle(rendered)) return rendered;
    const match = location.pathname.match(/\/products\/([^/]+)/);
    if (!match) return '';
    try { const handle = decodeURIComponent(match[1]); return validHandle(handle) ? handle : ''; } catch (_) { return ''; }
  };
  window.heRecWithPrevious = (url, previous = pageHandle()) => {
    const target = new URL(url, location.href);
    const match = target.pathname.match(/\/products\/([^/]+)/);
    if (validHandle(previous) && match && decodeURIComponent(match[1]) !== previous) target.searchParams.set('he_rec_prev', previous);
    return target.href;
  };
  window.heRecRememberProduct = handle => {
    recentRemember(handle);
    document.dispatchEvent(new CustomEvent('he-rec-history-updated'));
  };
  window.heRecRecordOutgoing = url => {
    try {
      const target = new URL(url, location.href);
      const match = target.pathname.match(/\/products\/([^/]+)/);
      if (match && (allowedBrand(target) || target.origin === location.origin)) recentRemember(decodeURIComponent(match[1]));
    } catch (_) {}
  };
  for (const name of ['click', 'auxclick']) document.addEventListener?.(name, event => {
    const link = event.target.closest?.('a[href]');
    if (link) window.heRecRecordOutgoing(link.href);
  }, { capture: true });
  const initRecentRoot = root => {
    if (root.heRecRecentCleanup) return;
    const current = root.getAttribute('data-he-rec-current-handle');
    if (!validHandle(current)) return;
    const incoming = new URL(location.href).searchParams.get('he_rec_prev');
    if (validHandle(incoming) && incoming !== current) recentRemember(incoming);
    recentRemember(current);
    const signals = new AbortController();
    let frame = 0, busy = false, pending = false;
    const getCard = async handle => {
      if (recentCards.has(handle)) return recentCards.get(handle);
      const locale = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const url = new URL(locale + 'products/' + encodeURIComponent(handle), location.origin);
      const response = await fetch(url, { credentials: 'same-origin', signal: signals.signal });
      if (!response.ok) return null;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = html.querySelector('template[data-he-rec-own-card]');
      if (!template || template.getAttribute('data-he-rec-eligible') !== 'true') return null;
      const card = { html: template.innerHTML, section: template.getAttribute('data-he-rec-source-section') };
      recentCards.set(handle, card);
      return card;
    };
    const refresh = async () => {
      frame = 0;
      if (signals.signal.aborted || !root.isConnected) return;
      if (busy) { pending = true; return; }
      const list = root.querySelector('.product-grid');
      if (!list) return;
      const content = root.querySelector('.he-art-recommendation-content');
      if (content) content.hidden = !list.children.length;
      busy = true;
      try {
        const maximum = Math.max(1, Number(root.getAttribute('data-he-rec-limit')) || 5);
        for (const handle of recentRead().filter(item => item !== current)) {
          const existing = [...list.children].find(item => item.getAttribute('data-he-rec-product-handle') === handle);
          if (existing) { if (content) content.hidden = false; return; }
          let card;
          try { card = await getCard(handle); } catch (error) { if (signals.signal.aborted) return; continue; }
          if (!card || signals.signal.aborted || !root.isConnected) continue;
          const latest = recentRead().find(item => item !== current);
          if (latest !== handle && pending) return;
          const sourceSection = card.section;
          const targetSection = root.getAttribute('data-section-id');
          const holder = document.createElement('template');
          holder.innerHTML = sourceSection ? card.html.split(sourceSection).join(targetSection) : card.html;
          const item = holder.content.querySelector('.grid__item');
          if (!item || item.getAttribute('data-he-rec-product-handle') === current) continue;
          const id = item.getAttribute('data-he-rec-product-id');
          if ([...list.children].some(node => node.getAttribute('data-he-rec-product-id') === id)) return;
          list.prepend(item);
          while (list.children.length > maximum) list.lastElementChild.remove();
          root.classList.add('product-recommendations--loaded');
          if (content) content.hidden = false;
          return;
        }
      } finally {
        busy = false;
        if (pending) { pending = false; schedule(); }
      }
    };
    const schedule = () => {
      if (signals.signal.aborted || frame) return;
      frame = requestAnimationFrame(refresh);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
    document.addEventListener('he-rec-history-updated', schedule, { signal: signals.signal });
    window.addEventListener('pageshow', schedule, { signal: signals.signal });
    for (const name of ['click', 'auxclick']) root.addEventListener(name, event => {
      const link = event.target.closest?.('.card__heading a');
      if (link) window.heRecRecordOutgoing(link.href);
    }, { capture: true, signal: signals.signal });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) root.heRecRecentCleanup();
    }, { signal: signals.signal });
    root.heRecRecentCleanup = () => { signals.abort(); observer.disconnect(); cancelAnimationFrame(frame); };
    schedule();
  };
  const bootRecent = () => document.querySelectorAll?.('product-recommendations[data-he-rec-current-handle]').forEach(initRecentRoot);
  window.heRecInitRecent = initRecentRoot;

  const pinMemory = new Map();
  const pinKey = section => 'he-rec-editor-pin-' + (window.Shopify?.theme?.id || '') + '-' + section;
  const pinEnabled = modal => Boolean(window.Shopify?.designMode && modal.hasAttribute('data-he-rec-editor-pin'));
  const savePinned = (modal, opener) => {
    if (!pinEnabled(modal)) return;
    const key=pinKey(modal.getAttribute('data-he-rec-modal'));
    const value=JSON.stringify({productUrl:opener.dataset.productUrl,fullUrl:opener.dataset.heRecFullUrl,brand:opener.dataset.heRecBrand||''});
    pinMemory.set(key,value);
    try { window.sessionStorage.setItem(key,value); } catch (_) {}
  };
  const clearPinned = modal => {
    const key=pinKey(modal.getAttribute('data-he-rec-modal'));pinMemory.delete(key);
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  };
  window.heRecRestorePinned = (root, section, enabled) => {
    if (!window.Shopify?.designMode) return;
    const key=pinKey(section);
    if (!enabled) { pinMemory.delete(key);try { window.sessionStorage.removeItem(key); } catch (_) {} return; }
    let saved;
    try { let raw=pinMemory.get(key);try{raw=window.sessionStorage.getItem(key)||raw;}catch(_){} saved=JSON.parse(raw||'null'); } catch (_) { return; }
    if (!saved?.productUrl) return;
    let product;
    try { product=new URL(saved.productUrl,location.href); if(product.origin!==location.origin||!product.pathname.includes('/products/'))return; } catch (_) { return; }
    const opener=[...root.querySelectorAll('[data-he-rec-quickshop] > button')].find(button=>{
      try { return new URL(button.dataset.productUrl,location.href).pathname===product.pathname; } catch (_) { return false; }
    });
    if (!opener) return;
    const selector=opener.closest('modal-opener')?.getAttribute('data-modal');
    const modal=selector&&document.querySelector(selector);
    if(modal&&!modal.hasAttribute('open')&&!modal.heRecPinRestoring){
      modal.heRecPinRestoring=true;
      Promise.resolve(modal.show(opener)).finally(()=>{modal.heRecPinRestoring=false;});
    }
  };

  if (!window.heRecQuickshopEnhance) {
    const nextPaint = () => new Promise(resolve => requestAnimationFrame(resolve));
    const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
    const pruneAfter = (node, stop) => {
      for (let current = node; current && current !== stop; current = current.parentElement) {
        while (current.nextElementSibling) current.nextElementSibling.remove();
      }
    };
    let hintSequence = 0;
    const addBrandHint = (product, submit, fullUrl) => {
      const target = new URL(fullUrl, location.href);
      if (target.origin === location.origin || !allowedBrand(target)) return;
      const names = {
        'heartjesusart.org': 'He Art®', 'heartjesusart.com': 'He Art®',
        'heartcooking.org': 'He Art cooking®', 'heartcooking.com': 'He Art cooking®',
        'wearenabledart.org': 'wearenabledart®', 'wearenabledart.com': 'wearenabledart®',
        'heartgardening.org': 'He Art® gardening', 'heartworship.org': 'He Art® music',
        'heartpoetry.org': 'He Art® poetry', 'seathletique.com': 'Seathletique'
      };
      const brand = canonicalBrand(product.dataset.heRecBrand || names[cleanHost(target.hostname)]);
      if (!brand) return;
      const hint = document.createElement('div');
      hint.className = 'he-rec-cart-hint';
      const row = document.createElement('div');
      row.className = 'he-rec-cart-hint-row';
      const note = document.createElement('span');
      note.id = 'HeRecBrandHint-' + (++hintSequence);
      note.setAttribute('data-he-rec-brand-label', '');
      note.textContent = 'ADD TO ' + brand.toUpperCase() + '’S BASKET';
      submit.setAttribute('data-he-rec-brand-button', '');
      const more = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = 'Learn more';
      const explanation = document.createElement('p');
      explanation.textContent = 'This item belongs to ' + brand + '. By selecting “Add it to basket” it automatically places it into your basket in the ' + brand + ' section. This is so you can do checkouts for each type of product from each brand. - To navigate back and forth, simply use the upper left tabs and explore more. Enjoy and God bless you!';
      more.append(summary, explanation);
      row.append(note, more);
      hint.appendChild(row);
      submit.after(hint);
      const describedBy = submit.getAttribute('aria-describedby');
      submit.setAttribute('aria-describedby', [describedBy, note.id].filter(Boolean).join(' '));
    };
    const prepare = (product, fullUrl) => {
      const submit = product.querySelector('.pdp-basket button[name="add"], product-form button[name="add"]');
      if (!submit) throw new Error('The product purchase button was not found.');
      const info = submit.closest('.product__info-container');
      const basket = submit.closest('.pdp-basket') || submit.closest('product-form');
      if (!info || !basket) throw new Error('The product layout was not found.');
      pruneAfter(basket, info);
      const buttons = submit.closest('.product-form__buttons');
      if (buttons) while (submit.nextElementSibling) submit.nextElementSibling.remove();
      product.querySelectorAll('.shopify-payment-button, .product__view-details').forEach(node => node.remove());
      const details = document.createElement('a');
      details.href = window.heRecWithPrevious(fullUrl);
      details.className = submit.className.replace(/\bloading\b/g, '') + ' he-rec-details';
      details.setAttribute('aria-label', 'VIEW FULL DETAILS');
      const label = submit.querySelector('span')?.cloneNode(true) || document.createElement('span');
      label.setAttribute('aria-hidden', 'true');
      details.appendChild(label);
      submit.after(details);
      details.addEventListener('click', () => {
        const variant = product.querySelector('input.product-variant-id, input[name="id"]')?.value;
        if (variant) {
          const target = new URL(fullUrl, location.href);
          target.searchParams.set('variant', variant);
          details.href = target.href;
        }
      });
      // Cross-brand note paused: keep the untouched native Add to Basket label and hover.
      const title = product.querySelector('.pdp-title h1, .product__title h1, h1');
      if (title) {
        let link = title.querySelector('a');
        if (!link) {
          link = document.createElement('a');
          while (title.firstChild) link.appendChild(title.firstChild);
          title.appendChild(link);
        }
        link.href = window.heRecWithPrevious(fullUrl);
        link.setAttribute('data-he-rec-title-link', '');
      }
      product.querySelectorAll('media-gallery').forEach(gallery => {
        const list = gallery.querySelector('.product__media-list');
        let controls = gallery.querySelector('[data-row-controls]');
        if (!list) return;
        if (!controls) {
          controls = document.createElement('div');
          controls.className = 'gallery-row-controls';
          controls.setAttribute('data-row-controls', '');
          controls.setAttribute('role', 'group');
          controls.setAttribute('aria-label', 'More product images');
          controls.hidden = true;
          controls.innerHTML = '<span class="gallery-row-label">More Images</span><button type="button" class="gallery-row-button gallery-row-button--previous" data-row-previous aria-label="Previous image"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" class="gallery-row-button" data-row-next aria-label="Next image"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
          const viewer = gallery.querySelector('[id^="GalleryViewer"]') || gallery;
          viewer.appendChild(controls);
        }
        gallery.dataset.rowWindow = 'true';
        gallery.dataset.courseHorizontal = 'true';
        gallery.querySelectorAll('.gallery-row-controls.quick-add-hidden').forEach(node => node.classList.remove('quick-add-hidden'));
        gallery.querySelectorAll('.slider-buttons').forEach(node => node.classList.add('quick-add-hidden'));
        if (!gallery.querySelector('[data-row-viewport]')) {
          const viewport = document.createElement('div');
          viewport.className = 'gallery-row-window';
          viewport.setAttribute('data-row-viewport', '');
          list.before(viewport);
          viewport.appendChild(list);
        }
        const image = list.querySelector('img');
        const width = Number(image?.getAttribute('width'));
        const height = Number(image?.getAttribute('height'));
        if (!gallery.style.getPropertyValue('--he-art-course-media-ratio') && width > 0 && height > 0) {
          gallery.style.setProperty('--he-art-course-media-ratio', String(width / height));
        }
      });
      return { details, submit };
    };
    const invertButton = (product, submit, details) => {
      const base = getComputedStyle(submit);
      const declaration = document.createElement('span').style;
      for (const style of product.querySelectorAll('style')) {
        const rule = style.textContent.match(/\.pdp-basket\s+\.product-form__submit:not\(:disabled\):hover\s*\{([^}]+)\}/);
        if (rule) { declaration.cssText = rule[1]; break; }
      }
      const resolveColor = (value, fallback) => {
        const variable = value?.match(/^var\((--[^,)]+)/)?.[1];
        return variable ? base.getPropertyValue(variable).trim() || fallback : value || fallback;
      };
      details.style.setProperty('--he-rec-details-bg', declaration.backgroundColor || '#ffffff');
      details.style.setProperty('--he-rec-details-border', declaration.borderColor || base.backgroundColor);
      details.style.setProperty('--he-rec-details-stroke', declaration.borderWidth || base.borderWidth);
      details.style.setProperty('--he-rec-details-ink', resolveColor(declaration.color, base.backgroundColor));
      details.style.setProperty('--he-rec-details-active-bg', base.backgroundColor);
      details.style.setProperty('--he-rec-details-active-ink', base.color);
      // Standard-layout fallback: mirror the visible label when no generated label exists.
      const visible = getComputedStyle(submit.querySelector('span') || submit, '::after');
      if (!visible.content || visible.content === 'none' || visible.content === 'normal') {
        details.textContent = 'VIEW FULL DETAILS';
        details.style.font = base.font;
        details.style.letterSpacing = base.letterSpacing;
      }
    };
    const bindLearnHover = (product, signal) => {
      const timers = new Map();
      product.querySelectorAll('.he-rec-cart-hint details').forEach(details => {
        const summary = details.querySelector('summary');
        const box = details.querySelector('p');
        if (!summary || !box || details.dataset.heRecHoverBound) return;
        details.dataset.heRecHoverBound = 'true';
        const cancel = () => { clearTimeout(timers.get(details)); timers.delete(details); };
        const open = () => { cancel(); details.open = true; };
        const later = () => {
          cancel();
          timers.set(details, setTimeout(() => {
            if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open = false;
          }, 300));
        };
        summary.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') open(); }, { signal });
        summary.addEventListener('focus', () => { if (summary.matches(':focus-visible')) open(); }, { signal });
        summary.addEventListener('click', event => {
          if (window.matchMedia('(hover: hover)').matches) { event.preventDefault(); open(); }
        }, { signal });
        details.addEventListener('pointerleave', event => { if (event.pointerType !== 'touch') later(); }, { signal });
        details.addEventListener('focusout', event => { if (window.matchMedia('(hover: hover)').matches || event.relatedTarget) later(); }, { signal });
        box.addEventListener('pointerenter', cancel, { signal });
        box.addEventListener('pointerleave', event => { if (event.pointerType !== 'touch') later(); }, { signal });
        details.addEventListener('keyup', event => { if (event.key === 'Escape') event.stopPropagation(); }, { signal });
        details.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); cancel(); details.open = false; }
        }, { signal });
      });
      signal.addEventListener('abort', () => { timers.forEach(clearTimeout); timers.clear(); }, { once: true });
    };
    const updateBrandButton = product => {
      const submit = product?.querySelector('.pdp-basket button[name="add"], product-form button[name="add"]');
      const hint = product?.querySelector('.he-rec-cart-hint');
      const note = hint?.querySelector('[data-he-rec-brand-label]');
      if (!submit || !hint || !note) return;
      const original = submit.querySelector('span') || submit;
      const generated = getComputedStyle(original, '::after');
      const typography = generated.content && !['none', 'normal'].includes(generated.content) ? generated : getComputedStyle(original);
      for (const property of ['font-family','font-size','font-weight','font-style','font-stretch','line-height','letter-spacing','text-transform','font-feature-settings','font-variation-settings','font-kerning','font-optical-sizing','word-spacing','text-shadow','-webkit-text-stroke-width']) {
        const value = typography.getPropertyValue(property);
        if (value) note.style.setProperty(property, value);
      }
      note.style.setProperty('-webkit-text-stroke-color', 'currentColor');
      const nativeStyle = getComputedStyle(original);
      const x = parseFloat(nativeStyle.left) || 0;
      const y = parseFloat(nativeStyle.top) || 0;
      hint.style.setProperty('--he-rec-label-x', x + 'px');
      hint.style.setProperty('--he-rec-label-y', y + 'px');
      hint.style.setProperty('--he-rec-label-inset', (8 + Math.abs(x)) + 'px');
      const buttonBox = submit.getBoundingClientRect();
      const hintBox = hint.getBoundingClientRect();
      const css = getComputedStyle(submit);
      const totalX = buttonBox.width / parseFloat(css.width);
      const totalY = buttonBox.height / parseFloat(css.height);
      if (totalX > 0 && totalY > 0) {
        hint.style.setProperty('--he-rec-button-left', (buttonBox.left - hintBox.left) / totalX + 'px');
        hint.style.setProperty('--he-rec-button-top', (buttonBox.top - hintBox.top) / totalY + 'px');
        hint.style.setProperty('--he-rec-button-width', buttonBox.width / totalX + 'px');
        hint.style.setProperty('--he-rec-button-height', buttonBox.height / totalY + 'px');
      }
      const details = product.querySelector('.he-rec-details');
      const pairs = { '--he-rec-hover-bg':'--he-rec-details-bg', '--he-rec-hover-border':'--he-rec-details-border', '--he-rec-hover-stroke':'--he-rec-details-stroke', '--he-rec-hover-ink':'--he-rec-details-ink' };
      for (const [name, source] of Object.entries(pairs)) {
        const value = details?.style.getPropertyValue(source);
        if (value) product.style.setProperty(name, value);
      }
    };
    const popupGeometry = (width, height, requested = 1200) => {
      const base = Math.min(requested, Math.max(1, width - 32));
      const start = requested + 400;
      const progress = Math.max(0, Math.min(1, (start - width) / Math.max(1, start - 770)));
      const envelope = width > 770 && width < start ? Math.sin(Math.PI * progress) : 0;
      const scale = 1 - .06 * envelope;
      const maxHeight = Math.max(80, (height - 32) / scale);
      const minHeight = Math.min(base * 740 / 1200 + 60 * envelope, maxHeight);
      const gutter = (width - base * scale) / 2;
      return { base, gutter, scale, maxHeight, minHeight, loadingWidth: base * .975, loadingHeight: minHeight * .975 };
    };
    const useResponsiveLayout = modal => {
      const signals = new AbortController();
      let frame = 0;
      let stopped = false;
      let product = null;
      let geometry = null;
      let measureGallery = false;
      let signature = '';
      const originals = new Map();
      const set = (node, name, value) => {
        if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value);
      };
      const updateGeometry = () => {
        const width = window.visualViewport?.width || window.innerWidth || document.documentElement.clientWidth;
        const height = window.visualViewport?.height || window.innerHeight;
        const requested = parseFloat(getComputedStyle(modal).getPropertyValue('--he-rec-popup-width')) || 1200;
        geometry = popupGeometry(width, height, requested);
        const next = [geometry.base, geometry.scale].join('/');
        if (next !== signature) { signature = next; measureGallery = true; }
        set(modal, '--he-rec-layout-width', geometry.base + 'px');
        set(modal, '--he-rec-popup-scale', String(geometry.scale));
        set(modal, '--he-rec-min-height', geometry.minHeight + 'px');
        set(modal, '--he-rec-max-height', geometry.maxHeight + 'px');
        set(modal, '--he-rec-loading-width', geometry.loadingWidth + 'px');
        set(modal, '--he-rec-loading-height', geometry.loadingHeight + 'px');
      };
      const unscaled = callback => {
        const panel = modal.querySelector('.quick-add-modal__content');
        if (!panel) return callback();
        const before = panel.style.getPropertyValue('transform');
        const priority = panel.style.getPropertyPriority('transform');
        panel.style.setProperty('transform', 'translate(-50%, -50%) scale(1)', 'important');
        try { return callback(); }
        finally {
          if (before) panel.style.setProperty('transform', before, priority);
          else panel.style.removeProperty('transform');
        }
      };
      const wrapGalleries = () => {
        if (!product) return;
        product.querySelectorAll('media-gallery').forEach(gallery => {
          if (originals.has(gallery)) return;
          const saved = {};
          for (const name of ['measureRowWindow', 'getRowWindowRows', 'moveRowWindow']) {
            if (typeof gallery[name] !== 'function') continue;
            saved[name] = gallery[name];
            gallery[name] = function (...args) { return unscaled(() => saved[name].apply(this, args)); };
          }
          if (Object.keys(saved).length) { originals.set(gallery, saved); measureGallery = true; }
        });
      };
      const updateTitle = () => {
        const title = product?.querySelector('.pdp-title');
        const heading = title?.querySelector('h1');
        const button = product?.querySelector('.pdp-basket .product-form__submit');
        if (!title || !heading || !button || !geometry) return;
        const style = getComputedStyle(title);
        const box = title.getBoundingClientRect();
        const cssWidth = parseFloat(style.width);
        const totalX = box.width / cssWidth;
        if (!(cssWidth > 0 && totalX > 0)) return;
        const buttonBox = button.getBoundingClientRect();
        const viewportBox = modal.modalContent.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(modal.modalContent).paddingRight) || 0;
        // Stop at the basket AND the real scroll viewport, not the page edge.
        const right = Math.min(buttonBox.right, viewportBox.right - padding * geometry.scale) - 2;
        const width = (right - box.left) / totalX;
        if (width > 0) set(title, '--he-art-title-boundary-width', Math.floor(width * 100) / 100 + 'px');
        const totalY = title.getBoundingClientRect().height / parseFloat(getComputedStyle(title).height);
        const lineHeight = parseFloat(getComputedStyle(heading).lineHeight);
        if (!(totalY > 0 && lineHeight > 0)) return;
        const range = document.createRange();
        range.selectNodeContents(heading);
        const wrapped = range.getBoundingClientRect().height > lineHeight * totalY * 1.5;
        const matrix = style.transform.match(/^matrix\(([^)]+)\)/);
        const ownScale = matrix ? Math.abs(parseFloat(matrix[1].split(',')[0])) || 1 : 1;
        // Exactly the listing's accepted 3 displayed-pixel wrapped-title gap.
        const gap = wrapped ? 3 / totalY : 0;
        const adjustment = wrapped ? 3 * ownScale / totalY - gap : 0;
        set(title, '--he-art-wrapped-title-gap', gap.toFixed(6) + 'px');
        set(title, '--he-art-wrapped-title-flow-adjustment', adjustment.toFixed(6) + 'px');
      };
      const schedule = () => {
        if (stopped) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          frame = 0;
          if (stopped) return;
          updateGeometry();
          wrapGalleries();
          if (measureGallery && product) {
            measureGallery = false;
            product.querySelectorAll('media-gallery').forEach(gallery => gallery.measureRowWindow?.());
          }
          updateTitle();
          updateBrandButton(product);
        });
      };
      const resize = new ResizeObserver(schedule);
      const mutation = new MutationObserver(schedule);
      window.addEventListener('resize', schedule, { signal: signals.signal });
      window.visualViewport?.addEventListener('resize', schedule, { signal: signals.signal });
      updateGeometry();
      return {
        attach(inserted) {
          product = inserted;
          // Replace only the popup's duplicate boundary observer, never the listing's.
          product.heArtTitleBoundaryCleanup?.();
          bindLearnHover(product, signals.signal);
          modal.modalContent.setAttribute('tabindex', '0');
          modal.modalContent.setAttribute('aria-label', 'Product details');
          [product, product.querySelector('.pdp-title'), product.querySelector('.pdp-basket')].filter(Boolean).forEach(node => resize.observe(node));
          mutation.observe(product, { childList: true, subtree: true });
          for (const name of ['click', 'input', 'change', 'load']) product.addEventListener(name, schedule, { capture: true, signal: signals.signal });
          document.fonts?.ready.then(schedule);
          if (customElements.get('media-gallery')) schedule();
          else customElements.whenDefined('media-gallery').then(() => { if (!stopped) schedule(); });
        },
        destroy() {
          stopped = true;
          signals.abort();
          resize.disconnect();
          mutation.disconnect();
          cancelAnimationFrame(frame);
          originals.forEach((saved, gallery) => Object.assign(gallery, saved));
        }
      };
    };
    window.heRecQuickshopEnhance = modal => {
      if (modal.heRecCompactReady) return;
      const Native = customElements.get('quick-add-modal');
      if (!Native) return;
      const Dialog = Object.getPrototypeOf(Native.prototype);
      const nativeHide = modal.hide.bind(modal);
      let load = null;
      let cleanFit = null;
      let responsive = null;
      let sequence = 0;
      modal.heRecCompactReady = true;
      modal.setAttribute('data-he-rec-compact', '');
      // Keep the original icon-close.svg rendered by the theme.
      modal.heRecCloseFromX = async () => {
        if (modal.heRecClosing) return;
        modal.heRecClosing = true;
        const ticket = ++sequence;
        load?.abort();
        modal.modalContent.inert = true;
        const close = modal.querySelector('[id^="ModalClose-"]');
        if (close) close.disabled = true;
        const svg = close?.querySelector('svg');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (svg && !reduced) {
          // Rotate the existing SVG artwork, not a new flex wrapper. The SVG
          // and circular button keep their original layout throughout closing.
          const rotor = svg.querySelector('path') || svg;
          rotor.classList.add('he-rec-close-spin-target');
          rotor.style.transformBox = 'view-box';
          rotor.style.transformOrigin = 'center';
          const degrees = Number.parseFloat(getComputedStyle(modal).getPropertyValue('--he-rec-close-spin')) || 0;
          const animation = rotor.animate?.([{transform:'rotate(0deg)'},{transform:'rotate(' + degrees + 'deg)'}], {duration:180,easing:'ease-in-out',fill:'forwards'});
          if (animation) { try { await animation.finished; } catch (_) {} }
        }
        if (ticket !== sequence) return;
        clearPinned(modal);
        modal.heRecForceClose = true;
        try { modal.hide(); } finally { modal.heRecForceClose = false; }
      };
      modal.hide = function (...args) {
        if (pinEnabled(this) && !this.heRecForceClose) return;
        this.heRecClosing = false;
        this.modalContent.inert = false;
        const close = this.querySelector('[id^="ModalClose-"]');
        if (close) close.disabled = false;
        this.querySelector('.he-rec-close-spin-target')?.getAnimations?.().forEach(animation => animation.cancel());
        sequence++;
        this.removeAttribute('data-he-rec-loading');
        const previousOpener = this.openedBy;
        previousOpener?.removeAttribute('aria-disabled');
        previousOpener?.classList.remove('loading');
        previousOpener?.querySelector('.loading__spinner')?.classList.add('hidden');
        if (previousOpener) delete previousOpener.dataset.heRecLoadingRequest;
        load?.abort();
        load = null;
        cleanFit?.();
        cleanFit = null;
        nativeHide(...args);
      };
      // The native close button was bound in its constructor; capture it so a
      // close during loading also cancels our request rather than reopening later.
      modal.addEventListener('click', event => {
        if (event.target.closest('[id^="ModalClose-"]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          modal.heRecCloseFromX();
        }
      }, true);
      modal.show = async function (opener) {
        this.heRecClosing = false;
        this.modalContent.inert = false;
        const close = this.querySelector('[id^="ModalClose-"]');
        if (close) close.disabled = false;
        this.querySelector('.he-rec-close-spin-target')?.getAnimations?.().forEach(animation => animation.cancel());
        savePinned(this, opener);
        const current = ++sequence;
        load?.abort();
        cleanFit?.();
        this.setAttribute('data-he-rec-loading', '');
        responsive = useResponsiveLayout(this);
        cleanFit = () => responsive.destroy();
        load = new AbortController();
        const request = load;
        this.openedBy = opener;
        opener.dataset.heRecLoadingRequest = String(current);
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');
        const fullUrl = opener.dataset.heRecFullUrl || opener.dataset.productUrl;
        const loading = document.createElement('div');
        loading.className = 'he-rec-load-state';
        loading.setAttribute('role', 'status');
        loading.textContent = 'Loading product…';
        this.modalContent.replaceChildren(loading);
        Dialog.show.call(this, opener);
        try {
          await nextPaint();
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!reduced) await pause(240);
          if (request.signal.aborted || current !== sequence) return;
          // Fetch the local product rendering; only actual navigation links use
          // the owning brand domain. No cross-domain cart requests are made.
          const response = await fetch(opener.dataset.productUrl, { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product could not be loaded.');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const product = html.querySelector('product-info');
          if (!product) throw new Error('Product information is unavailable.');
          this.preprocessHTML(product);
          product.dataset.heRecBrand = opener.dataset.heRecBrand || '';
          prepare(product, fullUrl);
          if (request.signal.aborted || current !== sequence || !this.hasAttribute('open')) return;
          const shell = document.createElement('div');
          shell.className = 'he-rec-fit-shell';
          const stage = document.createElement('div');
          stage.className = 'he-rec-fit-stage';
          shell.appendChild(stage);
          this.modalContent.replaceChildren(shell);
          this.removeAttribute('data-he-rec-loading');
          HTMLUpdateUtility.setInnerHTML(stage, product.outerHTML);
          const inserted = stage.querySelector('product-info');
          const submit = inserted.querySelector('.pdp-basket button[name="add"], product-form button[name="add"]');
          const details = inserted.querySelector('.he-rec-details');
          // Event listeners are not carried by outerHTML; retain the selected variant.
          inserted.querySelectorAll('.he-rec-details, [data-he-rec-title-link]').forEach(link => {
            link.addEventListener('click', () => {
              const variant = inserted.querySelector('input.product-variant-id, input[name="id"]')?.value;
              const target = new URL(fullUrl, location.href);
              if (variant) target.searchParams.set('variant', variant);
              link.href = window.heRecWithPrevious(target.href);
            });
          });
          invertButton(inserted, submit, details);
          updateBrandButton(inserted);
          bindOwningBrandCart(inserted, fullUrl);
          window.ProductModel?.loadShopifyXR?.();
          inserted.querySelector('product-component')?.dispatchViewEvent?.();
          responsive.attach(inserted);
          const viewed = new URL(fullUrl, location.href).pathname.match(/\/products\/([^/]+)/)?.[1];
          if (viewed) window.heRecRememberProduct(decodeURIComponent(viewed));
          requestAnimationFrame(() => {
            if (current === sequence && this.hasAttribute('open')) {
              trapFocus(this, this.modalContent);
            }
          });
        } catch (error) {
          if (request.signal.aborted || current !== sequence || !this.hasAttribute('open')) return;
          const state = document.createElement('div');
          state.className = 'he-rec-load-state';
          state.setAttribute('role', 'alert');
          const text = document.createElement('p');
          text.textContent = 'This product could not be loaded here.';
          const link = document.createElement('a');
          link.href = window.heRecWithPrevious(fullUrl);
          link.textContent = 'VIEW FULL DETAILS';
          state.append(text, link);
          this.removeAttribute('data-he-rec-loading');
          this.modalContent.replaceChildren(state);
        } finally {
          if (opener.dataset.heRecLoadingRequest === String(current)) {
            delete opener.dataset.heRecLoadingRequest;
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          }
        }
      };
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', consumeBrandHandoff, { once: true });
  else consumeBrandHandoff();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootRecent, { once: true });
  else bootRecent();
  document.dispatchEvent(new CustomEvent('he-rec-quickshop-ready'));
})();



